<template>
    <div id="app">
        <form class="" v-on:submit.prevent="submitSearch">
            <div class="input-group input-group-lg">
                <input type="text" v-model="searchQuery" class="form-control" placeholder="Gemeinde eingeben..."
                       @keyup="submitSearch">
                <button type="button" class="btn btn-primary" v-show="searchQuery" @click="removeSearchQuery"><i
                        class="fal fa-times"></i></button>
            </div>
        </form>
        <div v-show="searchQuery && isResult">
            <ul class="list-group">
                <a :href="elem.url" class="list-group-item list-group-item-action d-flex justify-content-between"
                   v-for="elem in gemeindeObj"
                   v-bind:key="elem">
                    {{ elem.name }}
                    <span class="icon">
              <i class="fal fa-long-arrow-right"></i>
          </span>
                </a>
            </ul>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    props: {
        rootNodeId: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            gemeindeObj: null,
            isResult: false,
            searchQuery: '',
        }
    },
    computed: {},
    ready: function () {
    },
    methods: {
        removeSearchQuery: function () {
            this.searchQuery = '';
            this.isResult = false;
        },
        submitSearch: function () {
            if (this.searchQuery == "") {
                this.isResult = false;
            } else if (this.searchQuery) {
                var reqURL = `/umbraco/md/gemeindeSearch/getList?searchTerm=${this.searchQuery}&rootNodeId=${this.rootNodeId}`;

                axios
                    .get(reqURL)
                    .then(response => {
                        if (response.data !== false) {
                            this.gemeindeObj = response.data;
                            this.isResult = true;
                            //console.log(response.data)
                        }
                    }).catch(error => {
                    console.log(error)
                });
            }

        }
    }
}
</script>

<style scoped>

</style>